import { IComponentOptions } from "angular";
import { PartTransactionController } from "./controller";

export const vsComponentName = "partPartTransaction";

export const partTransactionComponentOptions: IComponentOptions = {
  controller: PartTransactionController,
  controllerAs: "ctrl",
  template: require("!html-loader!./index.html").default,
  bindings: {
    defaultQuery: "<?",
    config: "<?",
  },
};
